import { render } from "./market-table.vue?vue&type=template&id=518dddbf&scoped=true"
import script from "./market-table.vue?vue&type=script&lang=ts"
export * from "./market-table.vue?vue&type=script&lang=ts"

import "./market-table.vue?vue&type=style&index=0&id=518dddbf&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-518dddbf"

export default script